import { CategoryBase } from '@shared/utils/category';
import { CaseStatus, MemberType, OfficerCaseRole } from './enums';
import { EvidenceStatus, EvidenceType } from '@shared/utils/evidence-management';

export class CaseDetails {
  constructor(
    public uid: string,
    public name: string,
    public incidentNumber: string,
    public status: CaseStatus,
    public agency: AgencyBase,
    public updatedOn: Date,
    public createdOn: Date,
    public officer: CaseOfficerBase,
    public officerCaseRole: OfficerCaseRole,
    public description: string,
    public categories: CategoryBase[],
    public tags: Tag[]
  ) {}
}

export class AgencyBase {
  constructor(public name: string, public shortName: string, public uid: string) {}
}

export class CaseOfficerBase {
  constructor(public uid: string, public firstName: string, public lastName: string, public emailAddress: string, public pictureFullPath: string | null) {}
}

export class Tag {
  constructor(public value: string, public uid: string) {}
}

export class CaseEvidence {
  constructor(
    public uid: string,
    public caseModel: UidModel,
    public caseFolder: UidModel | null,
    public recordedOn: Date,
    public uploadedOn: Date,
    public title: string,
    public incidentNumber: string,
    public incidentCadNumber: string | null,
    public type: EvidenceType,
    public status: EvidenceStatus,
    public officer: CaseOfficerBase,
    public thumbnailFullPath: string | null,
    public isLocked: boolean
  ) {}
}

export class UidModel {
  constructor(public uid: string) {}
}

export class CaseFolder {
  constructor(public createdOn: Date, public name: string, public uid: string) {}
}

export class TableData<T> {
  public length = this.data.length;

  constructor(public count: number, public data: T[]) {}
}

export class Case {
  constructor(
    public name: string,
    public incidentNumber: string,
    public status: CaseStatus,
    public updatedOn: Date,
    public createdOn: Date,
    public uid: string,
    public officer: CaseOfficerBase
  ) {}
}

export class CaseMemberDetails extends CaseOfficerBase {
  constructor(
    uid: string,
    firstName: string,
    lastName: string,
    emailAddress: string,
    pictureFullPath: string | null,
    public role: OfficerCaseRole,
    public memberType: MemberType | null = null,
    public customerUid: string | null = null
  ) {
    super(uid, firstName, lastName, emailAddress, pictureFullPath);
    this.role = role;
    this.memberType = memberType;
    this.customerUid = customerUid;
  }
}

export class CaseComment {
  constructor(public caseUid: string, public comment: string, public createdOn: Date, public officer: CaseOfficerBase) {}
}

export class GuestRecipient {
  constructor(public emailAddress: string) {}
}
